import { FC } from 'react';

import { ChatMessage } from './ChatMessage/ChatMessage';
import { ListPicker } from './ListPicker/ListPicker';
import { getMessageConfig } from './interactiveMessageUtils';

type InteractiveMessageProps = {
  item: connect.ChatTranscriptItem;
  showOptions?: boolean;
};

export const InteractiveMessage: FC<InteractiveMessageProps> = ({ item, showOptions = true }) => {
  const config = getMessageConfig(item);

  if (!config) {
    return null;
  }

  // currently only ListPicker type is implemented
  if (config.templateType === 'ListPicker') {
    return (
      <>
        <ChatMessage item={{ ...item, Content: config.data.content.title }} />
        {showOptions && <ListPicker data={config.data} aria-labelledby={item.Id} />}
      </>
    );
  }

  return null;
};

InteractiveMessage.displayName = 'InteractiveMessage';
